import { render, staticRenderFns } from "./DeleteVendor.vue?vue&type=template&id=60014630&scoped=true"
import script from "./DeleteVendor.vue?vue&type=script&lang=js"
export * from "./DeleteVendor.vue?vue&type=script&lang=js"
import style0 from "./DeleteVendor.vue?vue&type=style&index=0&id=60014630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60014630",
  null
  
)

export default component.exports